import { ResolveFn } from "@angular/router";
import { inject } from "@angular/core";
import { ISwapRequestEntity } from "@app/shared/swap-request/interfaces/swap-request.interface";
import { SwapRequestApiService } from "@app/shared/swap-request/services/swap-request-api.service";

export const getSwapRequestResolver: ResolveFn<ISwapRequestEntity> = (route, _state) => {
  const swapRequestApiService = inject(SwapRequestApiService);
  // Fetch the custom param name (defaults to 'id')
  // This allows flexibility for the param name
  const paramKey = route.data["swapRequestIdParamKey"] || "id";

  // Fetch the area ID from the route's parameter map
  const swapRequestId = route.paramMap.get(paramKey);

  if (!swapRequestId) {
    throw new Error(`Route param '${paramKey}' is missing or undefined`);
  }

  // Optionally fetch the dataShape from the route's `data` property
  const dataShape = route.data["swapRequestDataShape"];

  // Fetch the area data from the API service using the id and optional dataShape
  return swapRequestApiService.getSwapRequestById(swapRequestId, dataShape);
};
